import { Component, h, Host, Prop } from '@stencil/core';
import '@material/web/icon/icon';

@Component({
  tag: 'omk-icon',
  styleUrl: 'omk-icon.scss',
  shadow: true,
})
export class OmkIcon {
  @Prop() outlineVariant: boolean;

  render() {
    return (
      <Host style={{ '--omk-icon-fill': this.outlineVariant ? '0' : '1' }}>
        <md-icon>
          <slot></slot>
        </md-icon>
      </Host>
    );
  }
}
